<script>
import { Page } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        widgets: []
      },
      redirectRoute: { name: 'Pages List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            {
              component: 'el-tab-pane',
              attrs: {
                label: 'Ogólne'
              },
              children: [
                new fields.Input({
                  label: 'Tytuł',
                  modelPath: [this, 'form', 'title'],
                  multilingual: true
                }),
                new fields.Input({
                  label: 'Opis',
                  modelPath: [this, 'form', 'lead'],
                  type: 'textarea',
                  multilingual: true
                }),
                new fields.Switch({
                  label: 'Wcięcie w tle nagłówka',
                  modelPath: [this, 'form', 'indent']
                })
              ]
            },
            {
              component: 'el-tab-pane',
              attrs: {
                label: 'Widgety'
              },
              children: [
                new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })
              ]
            },
            {
              component: 'el-tab-pane',
              attrs: {
                label: 'SEO'
              },
              children: [
                new fields.Input({
                  label: 'Slug',
                  modelPath: [this, 'form', 'slug'],
                  multilingual: true,
                  condition: !!this.form.id
                }),
                new fields.Input({
                  label: 'Tytuł dla facebooka',
                  modelPath: [this, 'form', 'og_title'],
                  multilingual: true
                }),
                new fields.Input({
                  label: 'Opis dla facebooka',
                  modelPath: [this, 'form', 'og_description'],
                  type: 'textarea',
                  multilingual: true
                }),
                new fields.Image({
                  label: 'Zdjęcie dla facebooka',
                  modelPath: [this, 'form', 'image']
                }),
                new fields.Input({
                  label: 'Tytuł strony dla wyszukiwarki google',
                  modelPath: [this, 'form', 'meta_title'],
                  multilingual: true
                }),
                new fields.Input({
                  label: 'Opis dla wyszukiwarki google',
                  modelPath: [this, 'form', 'meta_description'],
                  type: 'textarea',
                  multilingual: true
                })
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    service() {
      return Page
    }
  }
}
</script>
